import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const buildSimpleLink = route => (
  <NavLink
    to={`/${route.path}`}
    className="tvt-header__navigation-link"
    activeClassName="tvt-header__navigation-link--active"
  >
    {route.icon && (
      <FontAwesomeIcon
        icon={route.icon}
        className="tvt-header__navigation-icon"
        size="1x"
      />
    )}
    {route.label}
  </NavLink>
);

const buildMenuLink = route => {
  let active = false;
  route.path.forEach(r => {
    if (
      window.location.pathname.substring(1, window.location.pathname.length) ===
      r.path
    ) {
      active = true;
    }
  });

  return (
    <Dropdown
      id={`tvt-header__navigation-link--${route.id}`}
      className="tvt-dropdown tvt-dropdown--dark tvt-header__navigation-dropdown"
    >
      <Dropdown.Toggle
        className={`tvt-dropdown__btn tvt-header__navigation-link${
          active ? '--active' : ''
        }`}
      >
        {route.icon && (
          <FontAwesomeIcon
            icon={route.icon}
            className="tvt-header__navigation-icon"
            size="1x"
          />
        )}
        {route.label}
      </Dropdown.Toggle>
      <Dropdown.Menu className="tvt-dropdown__menu">
        {map(route.path, r => (
          <MenuItem
            className="tvt-dropdown__menu-item"
            componentClass={NavLink}
            href={`/${r.path}`}
            key={r.path}
            to={`/${r.path}`}
          >
            {r.label}
          </MenuItem>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const NavigationItem = ({ isMenu, ...route }) => (
  <li key={route.label} className="tvt-header__navigation-item">
    {isMenu ? buildMenuLink(route) : buildSimpleLink(route)}
  </li>
);

NavigationItem.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.string.isRequired,
  isMenu: PropTypes.bool,
  label: PropTypes.string.isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        label: PropTypes.string
      })
    )
  ]).isRequired
};

NavigationItem.defaultProps = {
  icon: '',
  isMenu: false
};

export default NavigationItem;
